module.exports = __webpack_public_path__ + "img/152.f4266cd0.jpg";